<template>
  <div class="content">
    <div class="btn-container u-pull-right">
      <back-button></back-button>
    </div>
    <h1 class="font-light">Create User</h1>
    <div class="panel">
      To create a new user account please enter an
      <strong>email address</strong> and <strong>password</strong> for the User.
      The person will then receive an email inviting them to activate their
      account before they can login to the site.
    </div>
    <div class="form-section">
      <!-- Email field -->
      <div class="row ignore-screen level">
        <div class="offset-2  col-10 error" v-if="error.email">
          {{ error.email }}
        </div>
        <div class="col-2 ignore-screen u-text-right level-item font-bold">
          <span class="u-fill-width">Email:</span>
        </div>
        <div class="col-10 ignore-screen level-item">
          <input
            v-model="formData.email"
            v-bind:class="{ 'input-error': error.email }"
            type="email"
            placeholder="you@email.com"
          />
        </div>
      </div>
      <!-- Password field -->
      <div class="row ignore-screen level">
        <div class="offset-2 col-10 error" v-if="error.password">
          {{ error.password }}
        </div>
        <div class="col-2 ignore-screen u-text-right level-item font-bold">
          <span class="u-fill-width">Password:</span>
        </div>
        <div class="col-10 ignore-screen level-item">
          <input
            v-model="formData.password"
            v-bind:class="{ 'input-error': error.password }"
            type="password"
            placeholder="Super Secret Password"
          />
        </div>
      </div>
      <!-- Re-Password field -->
      <div class="row ignore-screen level">
        <div class="offset-2 col-10 error" v-if="error.re_password">
          {{ error.re_password }}
        </div>
        <div class="col-2 ignore-screen u-text-right level-item font-bold">
          <span class="u-fill-width">Re-type Password</span>
        </div>
        <div class="col-10 ignore-screen level-item">
          <input
            v-model="formData.re_password"
            v-bind:class="{ 'input-error': error.re_password }"
            type="password"
            placeholder="How well can you type?"
          />
        </div>
      </div>
      <space></space>
      <div class="row">
        <div class="u-text-right u-fill-width">
          <button
            class="btn-primary u-pull-right --tas-button-side-margin"
            v-on:click="submitForm"
          >
            <loading-spinner v-show="submit"></loading-spinner>
            <i class="fa-wrapper fa fa-upload pad-right" v-show="!submit"></i>
            Create
          </button>
        </div>
      </div>
    </div>
    <server-error v-bind:error="error.serverError"></server-error>
    <toast-success
      v-if="success"
      v-bind:label="'User Created'"
      v-bind:message="successMessage()"
      v-on:close="closeSuccess"
    ></toast-success>
  </div>
</template>
<style>
.--tas-button-side-margin {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
</style>
<script>
import { mapGetters } from "vuex";
import * as authService from "@/services/auth.service";
import { handleError } from "@/functions/handleError.function";
import ServerError from "@/components/ServerError";
import BackButton from "@/components/BackButton";
import LoadingSpinner from "@/components/LoadingSpinner";
import ToastSuccess from "@/components/ToastSuccess";

export default {
  name: "user-create",
  components: {
    ServerError,
    BackButton,
    LoadingSpinner,
    ToastSuccess
  },
  data: function() {
    return {
      formData: {
        email: "",
        password: "",
        re_password: ""
      },
      submit: false,
      success: false,
      successEmail: ""
    };
  },
  computed: {
    ...mapGetters("core", ["error"])
  },
  methods: {
    validate() {
      let is_valid = true;
      for (let field in this.formData) {
        if (this.formData[field] == "") {
          is_valid = false;
          let data = {};
          data[field] = "This field may not be blank";
          this.$store.commit("core/setError", data);
        }
        if (!this.formData.email.includes("@")) {
          is_valid = false;
          let data = { email: "You must enter a valid email address." };
          this.$store.commit("core/setError", data);
        }
        if (this.formData.password != this.formData.re_password) {
          is_valid = false;
          let data = { re_password: "Password's don't match. " };
          this.$store.commit("core/setError", data);
        }
      }
      return is_valid;
    },
    submitForm() {
      this.$store.commit("core/clearErrors");
      this.submit = true;
      this.success = false;
      let is_valid = this.validate();
      if (!is_valid) {
        this.submit = false;
        return;
      }
      // Call the auth.service directly as this never interacts with the Vuex
      // store
      authService
        .createUser(this.formData)
        .then(response => {
          this.submit = false;
          if (response.status == 201) {
            this.successEmail = response.data.email;
            this.success = true;
          }
        })
        .catch(error => {
          this.submit = false;
          let data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    successMessage() {
      let message =
        "The User account was sucessfully created. " +
        "An email has been sent to " +
        this.successEmail +
        ". " +
        "\nPlease follow the instructions in that email to activate " +
        "the account.";
      return message;
    },
    closeSuccess: function() {
      this.success = false;
    }
  },
  mounted() {
    this.$store.commit("core/clearErrors");
  }
};
</script>
